import React, { useState, useEffect } from 'react'
import FilterPage, { generateInitialValue } from '../fragments/filter-page'
import {
	action_fetch_collection,
	action_add_collection_list,
	action_fetch_collection_list,
	action_fetch_collection_sorters,
	action_fetch_collection_filter,
	__Default_Collection_Limit_For_DeskTop__
} from '../../../../../store/actions/pages/collection'

import {
	action_fetch_list_top_banner
} from '../../../../../store/actions/global'


import { filterItemsToString, getFilterItemsFromQuery, getTopBanner, getPageUrl } from '../../../../pages/listing/utils'
import { useDispatch, useSelector } from 'react-redux'
import { PageListProducts } from '../components/list'
import { getCollectionUrl } from '../../../../../utils/url'
import { useHistory, useLocation } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import { FormattedMessage } from 'react-intl'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Empty from '../fragments/empty-page'
import BlockImage from '../../../components/image/block-image'
import CountDown from '../../../../components/count-down'
import { useSensors } from '../../../../hooks/sensor'
import { generateFilter } from '../../../../utils/sensor'
import { isFlashSales } from '../../../../../utils/product'
import { Iconfont } from '../../../../components/icon/iconfont'
import TwitterEvents from '../../../../ads/events/twitter'
import BottomBannerTip from '../../../layout/fragments/bottom-banner'
import { PinterestAlert } from '../../../layout/fragments/alert-popup'

const getValidFilterItems = items => {
	const newItems = []

	items?.forEach(item => {
		if (['color', 'size', 'tags', 'category', 'category_ids'].indexOf(item.fieldName) >= 0 || item.fieldName?.indexOf('tags-') === 0) {
			newItems.push(item)
		}
	})
	return newItems
}

const parseParams = search => {
	if (!search) return
	let newParams = {}
	Object.keys(search).forEach(key => {
		if (search[key] instanceof Array) {
			newParams[key] = search[key]?.filter((value, index, s) => s.indexOf(value) === index).join?.(',')
		} else {
			newParams[key] = search[key]
		}
	})

	if (search?.sort_by) {
		newParams['parentSkus'] = search.sort_by
	}

	if (search?.recommend_data_source) {
		newParams['recommendDataSource'] = search.recommend_data_source
	}

	return newParams
}


const Collection = props => {
	useStyles(classes)
	const dispatch = useDispatch()
	const history = useHistory()
	const global = useSelector(state => state.global)
	const { listTopBanner } = global
	const pageCollection = useSelector((state) => state.pageCollection)
	const collection = pageCollection?.collection
	const banner = getTopBanner(listTopBanner, collection?.id)
	const sorters = pageCollection?.sorters
	const query = useQuery()
	const location = useLocation()
	const [originQuery, setOriginQuery] = useState(query)
	const baseUrl = getCollectionUrl(collection?.id, collection?.name)

	const [sensors, setSensors] = useState(useSensors())
	const filterStr = generateFilter(pageCollection?.filterData, pageCollection?.sorters)

	const flashProduct = pageCollection?.list?.find(p => !!isFlashSales(p))

	const showFlash = query?.ref_type === 'flash'
	const showPreOrder = query?.ref_type === 'preorder'

	const [data, setData] = useState({
		collectionId: collection?.id,
		sorter: (sorters instanceof Array) ? sorters?.[query.sort || 0]?.value : query.sort,
		startPrice: Number(query?.lowerPrice) || undefined,
		endPrice: Number(query?.higherPrice) || undefined,
		filterItems: generateInitialValue(query, pageCollection?.filterVo?.filterItems)
	})

	const sort = sorters?.findIndex(s => s.value === data?.sorter) || 0

	const [showPinterestAlert, setShowPinterestAlert] = useState(false)

	const filterHandle = (filterItems, sort, price) => {
		const filter = {
			collectionId: pageCollection?.collection?.id,
			sorter: (sorters instanceof Array) ? sorters?.[sort || 0]?.value : sort,
			startPrice: price?.minPrice || undefined,
			endPrice: price?.maxPrice || undefined,
			filterItems
		}
		setData(filter)
		dispatch(action_fetch_collection_list(filter, { limit: __Default_Collection_Limit_For_DeskTop__, recommendDataSource: originQuery?.recommend_data_source }, {}))
		const url = `${baseUrl}?${showFlash?'ref_type=flash&':(showPreOrder?'ref_type=preorder&':'')}${filterItemsToString(filterItems, sort, price)}`
		history.replace(url)
	}

	const onScroll = () => {
		dispatch(action_add_collection_list(data, { ...query, parentSkus: query?.sort_by, skip: pageCollection?.skip, limit: __Default_Collection_Limit_For_DeskTop__, recommendDataSource: originQuery?.recommend_data_source }, {}))
	}

	const onPage = page => {
		window.location.href = getPageUrl(window.location.href, page)
	}

	useEffect(() => {
		if(query?.utm_source){
			setShowPinterestAlert(true)
		}
		TwitterEvents.viewList({products: pageCollection?.list})
	}, [])

	const basePageUrl = `${location.pathname}${location.search}`

	return <React.Fragment>
		<FilterPage
			links={[
				{
					href: '#',
					title: <span>
						<span>{collection?.name}</span>
						{
							pageCollection?.total > 0 && <span className={classes.Total}>
								(<FormattedMessage id="count_items" values={{ total: pageCollection?.total }} defaultMessage="{total} Items" />)
							</span>
						}
					</span>,
					keywords: [],
				}
			]}

			extra={() => {
				return <div>
					{
						banner && banner.src && <div className={classes.Banner} style={{ marginTop: 20 }}>

							{
								banner?.isFlash && pageCollection?.list?.length > 0 && <div className={classes.Timmer}>
									<div className={classes.Title}>
										<FormattedMessage id="ends_in" defaultMessage="Ends In" />:
									</div>
									<CountDown showLabel showHour showDay offset={flashProduct?.promotion?.endTime - flashProduct?.promotion?.serverTime} numberClass={classes.Number} labelClass={classes.Label} dotClass={classes.Dotted} />
								</div>
							}

							<BlockImage sensors={{
								position: 1,
								content: banner.refId,
								type: '1',
								title: 'list'
							}} href={banner.href} title={banner.title} src={banner.src} width={banner.width} height={banner.height} />
						</div>
					}

					{
						showFlash && !!flashProduct && <div className={classes.FlashArea}>
							<div className={classes.Hd}>
								<Iconfont className={classes.Icon}>&#xe76a;</Iconfont>
								<span className={classes.Text}><FormattedMessage id="flash_sale" defaultMessage="Flash Sale" /></span>
							</div>
							<div className={classes.Bd}>
								<div className={classes.CountDown}>
									<span className={classes.EndsIn}>
										<FormattedMessage id="ends_in" defaultMessage="Ends In" />
									</span>
									<CountDown className={classes.Timing} showLabel showHour showDay offset={flashProduct?.promotion?.endTime - flashProduct?.promotion?.serverTime} numberClass={classes.Number} labelClass={classes.Label} dotClass={classes.Dotted} />
								</div>
							</div>
						</div>
					}


				</div>

			}}


			baseUrl={baseUrl}
			title={collection?.name}
			filterVO={pageCollection?.filterVo}
			sorters={pageCollection?.sorters}

			value={data?.filterItems}
			sort={sort}
			minPrice={data?.startPrice}
			maxPrice={data?.endPrice}
			showFooter
			onFilter={filterHandle}>
			{
				pageCollection?.finished && (!pageCollection?.list || pageCollection?.list?.length < 1) ? <Empty /> : <PageListProducts
				pagination={{
					total: pageCollection?.total,
					pageSize: __Default_Collection_Limit_For_DeskTop__,
					currentPage: Number(query?.page) || 1,
					onPage: onPage,
					baseUrl: basePageUrl
				}}
				isFlash={showFlash} isPreOrder={showPreOrder} filter={filterStr} sensors={sensors} products={pageCollection?.list} request={onScroll} loading={pageCollection?.loading} finished={pageCollection?.finished} />
			}

			<BottomBannerTip />
		</FilterPage>

		{ showPinterestAlert && <PinterestAlert/> }
	</React.Fragment>
	
}


Collection.fetchData = async (store, params, search, headers) => {

	const initialFilterItems = getFilterItemsFromQuery(search)
	const sort = search.sort || 0
	const sorters = await store.dispatch(action_fetch_collection_sorters({}, headers))
	const sorter = (sorters instanceof Array) ? sorters?.[sort]?.value : sort
	const collectionId = params.id || search?.collectionId
	const page = Number(search?.page) || 1

	const filter = {
		collectionId,
		sorter: sorter,
		startPrice: Number(search?.lowerPrice) || undefined,
		endPrice: Number(search?.higherPrice) || undefined,
		filterItems: getValidFilterItems(initialFilterItems),
	}

	const parsedParams = parseParams(search) || {}

	parsedParams.limit = __Default_Collection_Limit_For_DeskTop__
	parsedParams.skip = (page-1) * __Default_Collection_Limit_For_DeskTop__

	const values = await Promise.all([
		store.dispatch(action_fetch_collection(collectionId, headers)),
		store.dispatch(action_fetch_collection_list(filter, parsedParams, headers)),
		store.dispatch(action_fetch_collection_filter({ collectionId }, headers)),
		store.dispatch(action_fetch_list_top_banner(headers))
	])

	return [...values, sorters]
}

export default Collection